import HttpClient from '../../../services/http-client';
import { ISubmissionDashboardResponse } from '../../../../model/ser/dashboard/response/submission-dashboard-response';

const defaultPath = 'Dashboard';

// O Overview já traz indicadores, gráficos e próximas publicações em uma chamada
const getOverview = async (startDate: string, endDate: string, clientId?: number): Promise<ISubmissionDashboardResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/Overview`,
        params: { StartDate: startDate, EndDate: endDate, ClientId: clientId },
    }).then((response) => response.data as ISubmissionDashboardResponse);
};

const DashboardAppService = { getOverview };

export default DashboardAppService;
